import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./cadastrosMateriais.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import {
  getMateriaisCadastros,
  getMaterialUpdate,
  getMaterialById,
} from "../../services/api_cadastro_materiais";
import { getGruposMaterial } from "../../services/api_grupos_material";
import { getUnidadeMedida } from "../../services/api_unidade_medida";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import POLLING_INTERVAL from "../../hooks/Interval/interval";

const MaterialRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const [descricao, setDescricao] = useState("");
  const [modelo, setModelo] = useState("");
  const [id_grupo_material, setGrupoMaterial] = useState("");
  const [id_unidade_medida, setUnidadeMedida] = useState("");
  const [grupoMaterial, setGruposMaterial] = useState([]);
  const [unidadeMedida, setUnidadesMedida] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const inputRefs = {
    Descricao: useRef(null),
    Modelo: useRef(null),
    GrupoMaterial: useRef(null),
    UnidadeMedida: useRef(null),
  };

  useEffect(() => {
    const fetchMaterial = async () => {
      try {
        const response = await getMaterialById(id);
        //console.log(response);
        const material = response.data.Material; // Corrigido para acessar response.data.empresa
        if (material) {
          setDescricao(material.descricao || "");
          setModelo(material.modelo || "");
          setGrupoMaterial(material.id_grupo_material || "");
          setUnidadeMedida(material.id_unidade_medida || "");
        } else {
          console.error("Dados não encontrados na resposta:", response);
        }
      } catch (error) {
        console.error("Erro ao obter dados da unidade:", error);
      }
    };

    if (id) {
      fetchMaterial();
    }
  }, [id]);

  useEffect(() => {
    const fetchGruposMaterial = async () => {
      try {
        const response = await getGruposMaterial();
        //console.log(response);

        if (response) {
          const gruposMaterialAtivos = response.data.GruposMaterial.filter(
            (grupoMaterial) => grupoMaterial.deleted_at == null
          );
          setGruposMaterial(gruposMaterialAtivos);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
        //console.log(response);
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };
    fetchGruposMaterial();
    const interval = setInterval(()=>{
      fetchGruposMaterial();
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchUnidadesMedida = async () => {
      try {
        const response = await getUnidadeMedida();
        //console.log(response.data);

        if (response) {
          const unidadesMedidaAtivas = response.data.UnidadesMedida.filter(
            (unidadeMedida) => unidadeMedida.deleted_at == null
          );
          setUnidadesMedida(unidadesMedidaAtivas);
          setLoading(false);
        } else {
          console.error("A resposta da API não é uma array:");
        }
        //console.log(response.data);
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

    fetchUnidadesMedida();
    const interval = setInterval(()=>{
      fetchUnidadesMedida()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!descricao || !id_grupo_material || !id_unidade_medida) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento dos campos Descrição, Grupos de Material e Unidades de Medida são obrigatórios.",
      });

      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getMateriaisCadastros(body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar material:", response);
      }
    } catch (error) {
      console.error("Erro ao cadastrar material:", error);
    } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      const response = await getMaterialUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar material:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar a empresa:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        descricao,
        modelo,
        id_grupo_material,
        id_unidade_medida,
      };

      if (id) {
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleCaracteres = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setDescricao(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo não pode ultrapassar 50 caracteres",
      });
    }
  };

  const handleModelo = (e) => {
    const value = e.target.value;
    if (value.length <= 30) {
      setModelo(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo não pode ultrapassar 30 caracteres",
      });
    }
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Enter' && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus = nextFieldRef.current.inputRef || nextFieldRef.current;
  
      if (typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      } else {
        console.warn('O elemento de input não tem o método focus.');
      }
    }
  };
  

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Cadastro de Materiais" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form>
            <Row>
              <Col md={5} className="mb-3">
                <Form.Group controlId="formDescricao">
                  <Form.Label>Descrição</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite a Descrição"
                    value={descricao}
                    onChange={handleCaracteres}
                    ref={inputRefs.Descricao}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.UnidadeMedida)}
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="mb-3">
                <Form.Group controlId="formUniMedida">
                  <Form.Label>Unidade de Medida</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_unidade_medida}
                    onChange={(e) => setUnidadeMedida(e.target.value)}
                    ref={inputRefs.UnidadeMedida}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Modelo)}
                  >
                    <option value="">Selecione</option>
                    {unidadeMedida &&
                      unidadeMedida.map((id_unidade_medida) => (
                        <option
                          key={id_unidade_medida.id}
                          value={id_unidade_medida.id}
                        >
                          {id_unidade_medida.descricao}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formModelo">
                  <Form.Label>Modelo</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o Modelo"
                    value={modelo}
                    onChange={handleModelo}
                    ref={inputRefs.Modelo}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.GrupoMaterial)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formGrMateriais">
                  <Form.Label>Grupo de Materiais</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_grupo_material}
                    onChange={(e) => setGrupoMaterial(e.target.value)}
                    ref={inputRefs.GrupoMaterial}
                  >
                    <option value="">Selecione</option>
                    {grupoMaterial &&
                      grupoMaterial.map((id_grupo_material) => (
                        <option
                          key={id_grupo_material.id}
                          value={id_grupo_material.id}
                        >
                          {id_grupo_material.descricao}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default MaterialRegister;
